import { render, staticRenderFns } from "./activityH5LayOut.vue?vue&type=template&id=60c97b11&scoped=true&"
import script from "./activityH5LayOut.vue?vue&type=script&lang=js&"
export * from "./activityH5LayOut.vue?vue&type=script&lang=js&"
import style0 from "./activityH5LayOut.vue?vue&type=style&index=0&id=60c97b11&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c97b11",
  null
  
)

export default component.exports